import PropTypes from 'prop-types';
// @mui
import { MenuItem, TextField } from '@mui/material';

// ----------------------------------------------------------------------

BlogPostsSort.propTypes = {
  options: PropTypes.array,
  value: PropTypes.string,
  onSort: PropTypes.func,
};

export default function BlogPostsSort({ options = [], value = 'latest', onSort }) {
  const controlProps = onSort ? { value, onChange: onSort } : { defaultValue: value };

  return (
    <TextField select size="small" {...controlProps} sx={{ minWidth: 160 }}>
      {options.map((option) => (
        <MenuItem key={option.value} value={option.value}>
          {option.label}
        </MenuItem>
      ))}
    </TextField>
  );
}

